import { logger } from '@widget/utils/logger';
import config from 'next/config';

import type { FAQSectionData } from '../components/FAQSection/types';

const token = config().publicRuntimeConfig.storyblokWebKey;

export async function getFAQData(): Promise<FAQSectionData> {
  try {
    if (!token) {
      throw new Error('getFAQData: Storyblok token is missing in the configuration.');
    }

    const response = await fetch(
      `https://api.storyblok.com/v2/cdn/stories/data/mccompass/faq-section-data?token=${token}`,
    );

    if (!response.ok) {
      throw new Error(`getFAQData: Failed to fetch: ${response.statusText}`);
    }

    const data = await response.json();
    const content = data?.story?.content;
    if (!content) {
      logger.error('getFAQData: Unexpected response structure:', data);
      return { hasError: true };
    }

    return {
      headerText: content.headerText,
      items: content.items,
      hasError: false,
    };
  } catch (error) {
    logger.error('getFAQData: Error fetching FAQ section data:', error);
    return { hasError: true };
  }
}
